import { FC } from 'react';
import { Button } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

import { EripContent, IErip } from '../../../components/PaymentModal/PaymentModal';
import { TrainingGroup } from '../CourseEnrollment.const';
import css from '../CourseEnrollment.module.css';

const PAYMENT_NOTE: Record<string, string> = {
  requisites: 'Скачайте счёт на оплату и произведите оплату банковским переводом. После оплаты отправьте подтверждение на office@rabt.by — доступ к курсу будет открыт в течение рабочего дня.',
};

interface Props {
  contractNumber: string;
  group: TrainingGroup | undefined;
  email: string;
  paymentMethod: string;
  eripData: IErip | null;
  invoiceUrl?: string | null;
  onMyCourses: () => void;
  onCoursesList: () => void;
}

const DoneStep: FC<Props> = ({
  contractNumber,
  group,
  email,
  paymentMethod,
  eripData,
  invoiceUrl,
  onMyCourses,
  onCoursesList,
}) => (
  <div className={css.DonePage}>
    <span className={css.DoneIcon}>
      <CheckCircleFilled />
    </span>
    <h2 className={css.DoneTitle}>Договор оформлен</h2>
    <p className={css.DoneText}>
      Договор {contractNumber} успешно создан. Группа: {group?.name} (
      {group?.startDate} — {group?.endDate}).
    </p>
    {paymentMethod === 'erip' && eripData ? (
      <div className={css.EripWrapper}>
        <EripContent
          eripCode={eripData}
          onClose={onMyCourses}
          onSuccess={onMyCourses}
        />
      </div>
    ) : (
      <>
        {PAYMENT_NOTE[paymentMethod] && (
          <p className={css.DoneText}>{PAYMENT_NOTE[paymentMethod]}</p>
        )}
        {paymentMethod === 'requisites' && invoiceUrl && (
          <div style={{ marginBottom: 16 }}>
            <Button
              type='primary'
              href={invoiceUrl}
              target='_blank'
              rel='noopener noreferrer'
            >
              Скачать счёт на оплату (DOCX)
            </Button>
          </div>
        )}
        <div className={css.PrimaryActions} style={{ marginBottom: 0 }}>
          <Button className={css.ViewContractBtn} onClick={onMyCourses}>
            В мои курсы
          </Button>
          <Button className={css.PayBtn} onClick={onCoursesList}>
            К списку курсов
          </Button>
        </div>
      </>
    )}
  </div>
);

export default DoneStep;
